module.exports = ".footer{\n\t\n\t\n\t/*margin-bottom: 30px;*/\n\theight: 15px;\n\tbottom: 0;\n\tposition: fixed;\n\twidth: 100%;\n\tz-index: 450;\n\tbackground-image: url('/assets/images/barre.PNG');\n\tbackground-repeat: no-repeat;\nbackground-size: cover;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/footer/footer.component.css
// module id = ./src/app/common/footer/footer.component.css
// module chunks = main